import React from "react";
import { BadgeCheck } from "lucide-react";

/**
 * "Verified Seller" badge. Compact pill — fits next to seller name/rating.
 *
 * Renders nothing when `verified` is falsy so we can drop it next to every
 * seller name without conditionals at every callsite.
 *
 * Variants:
 *   - compact (default): icon + short label, fits inside a listing card row
 *   - full: icon + longer label, used on listing-detail/seller-profile views
 */
export const VerifiedSellerBadge = ({ verified, variant = "compact", className = "" }) => {
  if (!verified) return null;
  const isFull = variant === "full";
  return (
    <span
      data-testid="verified-seller-badge"
      title="Verified Seller — Stripe onboarded and has completed at least one sale"
      className={`inline-flex items-center gap-1 rounded-full border-2 border-gray-900 bg-[#DBF6E5] text-[#0F5132] text-[10px] font-black uppercase tracking-wide ${
        isFull ? "px-2.5 py-1" : "px-1.5 py-0.5"
      } ${className}`}
    >
      <BadgeCheck className={isFull ? "w-3.5 h-3.5" : "w-3 h-3"} />
      {isFull ? "Verified seller" : "Verified"}
    </span>
  );
};

export default VerifiedSellerBadge;
